<template>
  <div style="width: 100%">
    <div class="section-group">
      <div class="row">
        <div class="col-12">
          <N3Vue></N3Vue>
        </div>
      </div>
    </div>
    <div class="select_category" v-if="$route.query.cateName">
      {{ $route.query.cateName }}
    </div>
    <cardList></cardList>
  </div>
</template>

<script>
import cardList from "@/components/blog/cardList";
import N3Vue from "@/components/Ad/N3.vue";
export default {
  components: { cardList, N3Vue },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blog/category.vue